import glamorous from "glamorous"
import { css } from "glamor"
import style from "utils/style"

const LoadingIndicator = glamorous.div(
  {
    width: 40,
    height: 40,
    border: "5px solid",
    margin: "2rem auto",
    borderColor: style.colors.darkerGray,
    borderRadius: "50%",
    borderTop: "5px solid",
    borderTopColor: style.colors.green,
    borderRight: "5px solid",
    borderRightColor: style.colors.green,
    animation: `${css.keyframes({
      "0%": { transform: `rotate(0deg)` },
      "100%": { transform: `rotate(360deg)` },
    })} 1.5s linear infinite`,
  },
  ({ margin }) => ({ margin })
)

export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/index.js